/* Saint Véra · página da Mala (sections/sv-mala-page.liquid). Estado final de proposta-ideal-codex/showroom.js
   (malaPage V.mala=1 + tripSlot + packSummary) com dados reais do Liquid.
   Regras: 3 momentos; destino troca o trio; Trocar abre a lista real; Repetir copia a peça do primeiro dia;
   repetir NÃO soma unidade (resumo e sacola usam produtos distintos); tamanho/cor escolhidos por produto antes
   de SV.cart.add; sem desconto de kit. Estado guardado em SV.store('mala'). */
(function () {
  'use strict';
  if (window.customElements && customElements.get('sv-mala-page')) return;

  var ARROW = '<svg class="sv-mp-ic" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 12h16m-6-6 6 6-6 6"/></svg>';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function sv() { return window.SV || null; }
  function money(c) {
    var S = sv();
    if (S && S.money) return S.money(c);
    return 'R$ ' + (Math.round(c) / 100).toFixed(2).replace('.', ',');
  }
  function pix(c) { var S = sv(); return S && S.pix ? S.pix(c) : Math.floor((c * 95 + 50) / 100); }
  function inst(c) {
    var S = sv(), i = S && S.installment ? S.installment(c) : null;
    if (!i) return '';
    return 'em até ' + i.n + 'x' + (i.interest ? '*' : '') + ' de ' + money(i.value);
  }
  function uniq(list) {
    var out = [];
    list.forEach(function (x) { if (x && out.indexOf(x) < 0) out.push(x); });
    return out;
  }

  class SvMalaPage extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      var raw = this.querySelector('[data-mp-data]');
      try { this.data = JSON.parse(raw.textContent); } catch (e) { return; }
      var P = this.data.products || {};
      // destinos só com produtos existentes; slot vazio herda o primeiro produto válido do destino
      this.dests = (this.data.dests || []).map(function (d) {
        var ok = d.slots.filter(function (h) { return P[h]; });
        return { name: d.name, slots: d.slots.map(function (h) { return P[h] ? h : ok[0]; }), valid: ok.length > 0 };
      });
      if (!this.dests.some(function (d) { return d.valid; })) return; // sem dado: a página mostra só o título
      this.swapList = uniq([].concat.apply([], this.dests.map(function (d) { return d.slots; })).concat(this.data.swap || [])).filter(function (h) { return P[h]; });

      var saved = sv() && sv().store ? sv().store.get('mala', null) : null;
      this.dest = 0;
      this.slots = this.dests[0].slots.slice();
      if (saved && typeof saved.dest === 'number' && this.dests[saved.dest] && Array.isArray(saved.slots) && saved.slots.length === 3 && saved.slots.every(function (h) { return P[h]; })) {
        this.dest = saved.dest;
        this.slots = saved.slots.slice();
      }
      this.pick = {};
      this.q = function (s) { return this.querySelector(s); };
      this.dialog = this.q('[data-mp-dialog]');
      this._onClick = this.onClick.bind(this);
      this._onChange = this.onChange.bind(this);
      this.addEventListener('click', this._onClick);
      this.addEventListener('change', this._onChange);
      this._onClose = this.onDialogClose.bind(this);
      this.dialog.addEventListener('close', this._onClose);
      this._ready = true;
      this.render();
    }
    disconnectedCallback() {
      if (!this._ready) return;
      this.removeEventListener('click', this._onClick);
      this.removeEventListener('change', this._onChange);
      this.dialog.removeEventListener('close', this._onClose);
      if (this.dialog.open) this.dialog.close();
      this._ready = false;
    }
    save() {
      var S = sv();
      if (S && S.store) S.store.set('mala', { dest: this.dest, slots: this.slots });
    }
    distinct() { return uniq(this.slots); }

    render() {
      var P = this.data.products, self = this, moments = this.data.moments;
      this.querySelectorAll('[data-dest]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(+b.dataset.dest === self.dest));
      });
      var label = this.q('[data-mp-label]');
      label.textContent = this.dests[this.dest].name + '. ' + (this.data.coverSuffix || '');

      this.q('[data-mp-timeline]').innerHTML = this.slots.map(function (h, i) {
        var p = P[h], repeat = self.slots.slice(0, i).indexOf(h) > -1;
        var price = repeat
          ? '<p>Sem cobrar outra unidade</p>'
          : (p.compare > p.price ? '<s class="sv-was"><span class="visually-hidden">De </span>' + money(p.compare) + '</s>' : '') + '<p class="sv-mp__pix">' + money(pix(p.price)) + '<small>no Pix</small></p>' + (inst(p.price) ? '<p class="sv-mp__inst">' + esc(inst(p.price)) + '</p>' : '');
        return '<article class="sv-mp__slot">' +
          (p.img ? '<img src="' + esc(p.img) + '" width="80" height="108" loading="lazy" alt="' + esc(p.title) + '">' : '<span></span>') +
          '<div><h3>' + esc(moments[i]) + '</h3>' +
          '<p class="sv-mp__name"><a href="' + esc(p.url) + '">' + esc(p.name) + '</a>' + (repeat ? ' · repete uma roupa' : '') + '</p>' +
          price +
          '<p>' + (p.length ? esc(p.length) + ' cm' : 'Consulte as medidas') + '</p>' +
          (p.available ? '' : '<p>Esgotado no momento</p>') +
          '</div><div class="sv-mp__actions">' +
          '<button type="button" class="sv-mp-link" data-swap="' + i + '" aria-haspopup="dialog" aria-label="Trocar a peça de ' + esc(moments[i].toLowerCase()) + '">Trocar</button>' +
          (i ? '<button type="button" class="sv-mp-link" data-repeat="' + i + '" aria-label="Repetir em ' + esc(moments[i].toLowerCase()) + ' a peça do primeiro dia">Repetir</button>' : '') +
          '</div></article>';
      }).join('');

      var ids = this.distinct();
      var total = ids.reduce(function (s, h) { return s + P[h].price; }, 0);
      var sum = this.q('[data-mp-summary]');
      sum.hidden = false;
      this.q('[data-mp-count]').textContent = ids.length + (ids.length === 1 ? ' produto' : ' produtos');
      this.q('[data-mp-total]').textContent = money(pix(total)) + ' no Pix';
      this.q('[data-mp-open-pick]').disabled = !ids.some(function (h) { return P[h].available; });
    }

    onClick(e) {
      if (e.target === this.dialog) { this.closeDialog(); return; } // toque no véu
      var t = e.target.closest('button, [data-mp-close]');
      if (!t || !this.contains(t)) return;
      var d = t.dataset;
      if (d.dest !== undefined) {
        this.dest = +d.dest;
        this.slots = this.dests[this.dest].slots.slice();
        this.save(); this.render();
      } else if (d.repeat !== undefined) {
        this.slots[+d.repeat] = this.slots[0];
        this.save(); this.render();
        var r = this.querySelector('[data-repeat="' + d.repeat + '"]'); if (r) r.focus();
      } else if (d.swap !== undefined) {
        this.openSwap(+d.swap, t);
      } else if (d.slotPick !== undefined) {
        var slot = +this.dialog.dataset.slot;
        this.slots[slot] = d.slotPick;
        this.save(); this.render();
        this.closeDialog();
      } else if (d.mpOpenPick !== undefined) {
        this.openPick(t);
      } else if (d.opt !== undefined) {
        var st = this.pick[d.handle];
        st.opts[+d.opt] = d.value;
        this.renderPick();
      } else if (d.mpAdd !== undefined) {
        this.addToBag(t);
      } else if (d.mpClose !== undefined) {
        this.closeDialog();
      }
    }
    onChange(e) {
      var t = e.target;
      if (t.dataset && t.dataset.include !== undefined) {
        this.pick[t.dataset.include].include = t.checked;
        this.renderPick();
      }
    }

    /* ---------- folha ---------- */
    openDialog(trigger, title, sub) {
      this._trigger = trigger;
      this.q('[data-mp-dlg-title]').textContent = title;
      this.q('[data-mp-dlg-sub]').textContent = sub || '';
      if (!this.dialog.open) {
        this.dialog.showModal();
        if (sv() && sv().lockScroll) { sv().lockScroll(); this._locked = true; }
      }
    }
    closeDialog() { if (this.dialog.open) this.dialog.close(); }
    onDialogClose() {
      if (this._locked) { sv().unlockScroll(); this._locked = false; }
      var t = this._trigger;
      if (t && t.isConnected) t.focus();
      else if (this.dialog.dataset.slot !== undefined) {
        var b = this.querySelector('[data-swap="' + this.dialog.dataset.slot + '"]'); if (b) b.focus();
      }
      this.dialog.removeAttribute('data-mode');
    }

    openSwap(slot, trigger) {
      var P = this.data.products, self = this, moment = this.data.moments[slot];
      this.dialog.dataset.slot = slot;
      this.dialog.dataset.mode = 'swap';
      this.q('[data-mp-dlg-body]').innerHTML = '<div class="sv-mp-grid">' + this.swapList.map(function (h) {
        var p = P[h];
        return '<button type="button" class="sv-mp-pick" data-slot-pick="' + esc(h) + '" aria-current="' + (self.slots[slot] === h) + '"' + (p.available ? '' : ' disabled') + '>' +
          (p.img ? '<img src="' + esc(p.img) + '" width="240" height="320" loading="lazy" alt="">' : '') +
          '<b class="sv-mp__name">' + esc(p.name) + '</b>' +
          '<span>' + (p.available ? money(pix(p.price)) + ' no Pix' : 'Esgotado') + '</span>' +
          (p.available && inst(p.price) ? '<span>' + esc(inst(p.price)) + '</span>' : '') +
          '</button>';
      }).join('') + '</div>';
      this.q('[data-mp-dlg-foot]').innerHTML = '<a class="sv-mp-link" href="' + esc(this.data.collectionUrl) + '">Ver a coleção completa ' + ARROW + '</a>';
      this.openDialog(trigger, 'Trocar a peça deste dia', moment);
      var cur = this.dialog.querySelector('[aria-current="true"]') || this.dialog.querySelector('.sv-mp-pick');
      if (cur) cur.focus();
    }

    /* ---------- tamanhos por produto ---------- */
    openPick(trigger) {
      var P = this.data.products, self = this;
      var ids = this.distinct().filter(function (h) { return P[h].available; });
      var next = {};
      ids.forEach(function (h) {
        var p = P[h], old = self.pick[h];
        if (old) { next[h] = old; return; }
        var first = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
        // opções com um valor só ficam escolhidas; cor começa na primeira variante disponível; tamanho é escolha da cliente
        var opts = p.options.map(function (name, k) {
          var vals = uniq(p.variants.map(function (v) { return v.options[k]; }));
          if (vals.length === 1) return vals[0];
          return /tamanho|size/i.test(name) ? '' : first.options[k];
        });
        next[h] = { opts: opts, include: true };
      });
      this.pick = next;
      this.pickIds = ids;
      this.dialog.removeAttribute('data-slot');
      this.dialog.dataset.mode = 'pick';
      this.openDialog(trigger, ids.length > 1 ? 'Escolha as peças e os tamanhos' : 'Escolha o tamanho', 'Cada produto entra uma vez na sacola, com o seu próprio tamanho.');
      this.renderPick();
      var f = this.dialog.querySelector('.sv-mp-chip:not([disabled])'); if (f) f.focus();
    }
    variantFor(h) {
      var p = this.data.products[h], st = this.pick[h];
      if (st.opts.some(function (o) { return !o; })) return null;
      return p.variants.filter(function (v) { return v.options.every(function (o, k) { return o === st.opts[k]; }); })[0] || null;
    }
    renderPick() {
      var P = this.data.products, self = this;
      var focusKey = document.activeElement && document.activeElement.dataset ? document.activeElement.dataset.key : null;
      this.q('[data-mp-dlg-body]').innerHTML = this.pickIds.map(function (h) {
        var p = P[h], st = self.pick[h], v = self.variantFor(h), price = v ? v.price : p.price;
        var multi = self.pickIds.length > 1;
        var optsHtml = p.options.map(function (name, k) {
          var vals = uniq(p.variants.map(function (x) { return x.options[k]; }));
          if (vals.length < 2) return '';
          return '<p class="sv-mp-row__opt" id="mp-o-' + esc(h) + '-' + k + '">' + (/tamanho|size/i.test(name) ? 'Escolha o tamanho desta peça' : esc(name)) + (st.opts[k] ? ': <b>' + esc(st.opts[k]) + '</b>' : '') + '</p>' +
            '<div class="sv-mp-row__chips" role="group" aria-labelledby="mp-o-' + esc(h) + '-' + k + '">' + vals.map(function (val) {
              var avail = p.variants.some(function (x) {
                return x.available && x.options[k] === val && x.options.every(function (o, j) { return j === k || !st.opts[j] || o === st.opts[j]; });
              });
              var key = h + '|' + k + '|' + val;
              return '<button type="button" class="sv-mp-chip" data-handle="' + esc(h) + '" data-opt="' + k + '" data-value="' + esc(val) + '" data-key="' + esc(key) + '" aria-pressed="' + (st.opts[k] === val) + '"' + (avail ? '' : ' disabled') + '>' + esc(val) + '</button>';
            }).join('') + '</div>';
        }).join('');
        return '<div class="sv-mp-row">' +
          (p.img ? '<img src="' + esc(p.img) + '" width="70" height="100" loading="lazy" alt="">' : '<span></span>') +
          '<div><h3 class="sv-mp__name">' + esc(p.name) + '</h3>' +
          (p.compare > price ? '<s class="sv-was"><span class="visually-hidden">De </span>' + money(p.compare) + '</s>' : '') +
          '<p class="sv-mp__pix">' + money(pix(price)) + '<small>no Pix</small></p>' +
          (multi ? '<label class="sv-mp-include"><input type="checkbox" data-include="' + esc(h) + '"' + (st.include ? ' checked' : '') + '> Quero esta peça</label>' : '') +
          '<div' + (st.include ? '' : ' hidden') + '>' + optsHtml + '</div></div></div>';
      }).join('');

      var chosen = this.pickIds.filter(function (h) { return self.pick[h].include; });
      var ready = chosen.length > 0 && chosen.every(function (h) { var v = self.variantFor(h); return v && v.available; });
      var total = chosen.reduce(function (s, h) { var v = self.variantFor(h); return s + (v ? v.price : P[h].price); }, 0);
      var missing = chosen.filter(function (h) { return !self.variantFor(h); }).length;
      this.q('[data-mp-dlg-foot]').innerHTML =
        '<div class="sv-mp-foot-row"><span>' + chosen.length + (chosen.length === 1 ? ' produto' : ' produtos') + '</span><b>' + money(pix(total)) + ' no Pix</b></div>' +
        '<button type="button" class="sv-mp-btn" data-mp-add' + (ready ? '' : ' disabled') + '>' +
        (ready ? 'Adicionar à sacola' : missing ? 'Escolha o tamanho de cada peça' : 'Escolha ao menos uma peça') + '</button>' +
        '<p class="sv-mp__status" role="status" data-mp-dlg-status></p>';
      if (focusKey) {
        var back = this.dialog.querySelector('[data-key="' + (window.CSS && CSS.escape ? CSS.escape(focusKey) : focusKey) + '"]');
        if (back) back.focus();
      }
    }
    addToBag(btn) {
      var self = this, S = sv();
      var items = this.pickIds.filter(function (h) { return self.pick[h].include; }).map(function (h) {
        return { id: self.variantFor(h).id, quantity: 1 };
      });
      if (!items.length || !S || !S.cart) return;
      btn.disabled = true;
      btn.textContent = 'Adicionando…';
      var status = this.q('[data-mp-dlg-status]');
      S.cart.add(items, { context: 'mala', target: btn }).then(function () {
        self.closeDialog();
        self.q('[data-mp-status]').textContent = items.length + (items.length === 1 ? ' peça adicionada' : ' peças adicionadas') + ' à sacola.';
      }).catch(function (err) {
        btn.disabled = false;
        btn.textContent = 'Adicionar à sacola';
        status.textContent = (err && err.response && err.response.description) || 'Não foi possível adicionar agora. Tente de novo.';
      });
    }
  }

  customElements.define('sv-mala-page', SvMalaPage);
})();
